import React, { Fragment, useCallback, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { toggleProfileMenu, hideAllMenus } from "store/application/application-action";
import { IAppState } from "store/app-state";
import { metrics } from "utils/metrics";
import { getTabStatus, TABS } from "./helpers";
import { ApplicationFooter } from "./ApplicationFooter";
import ProfileMenu from "../../UI/ProfileMenu";
import { onOpenAuthPopup } from "components/popups/PopupDispatcher";

const ApplicationFooterContainer = () => {
  const currentUserName = useSelector((state: IAppState) => state.user.currentUser?.username) || null;
  const isProfileMenuOpen = useSelector((state: IAppState) => state.application.isProfileMenuOpen);
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const tabStatuses = useMemo(() => getTabStatus(pathname, currentUserName), [pathname, currentUserName]);

  const sendMetrics = async (tabName: string) => {
    await metrics.sendMenuButtonClicked({
      name: tabName
    });
  };

  const isTabActive = (tab: string) => tabStatuses[tab];

  const onProfileClick = useCallback(() => {
    currentUserName ? dispatch(toggleProfileMenu()) : onOpenAuthPopup();
    sendMetrics(TABS.profile);
  },[dispatch, currentUserName]);

  const onSendMetricAndCloseMenu = (tabName: string) => {
    dispatch(hideAllMenus());
    sendMetrics(tabName);
  };

  return (
    <Fragment>
      <ApplicationFooter
        currentUserName={currentUserName}
        isTabActive={isTabActive}
        onProfileClick={onProfileClick}
        onSendMetricAndCloseMenu={onSendMetricAndCloseMenu}
      />
      {isProfileMenuOpen && <ProfileMenu />}
    </Fragment>
  );
};

export default ApplicationFooterContainer;
